import React from "react";
import { projects } from "../../data";
import "./index.css";
import Image from "../elements/Image";
import { PORTFOLIO_TYPE } from "../../consts/config";

export const FooterProjects = () => {
  return (
    <div className="main-container projects-heading">
      <h4>Projects</h4>
      <div className="projects-container footer-details-rep">
        {projects[PORTFOLIO_TYPE]?.map((project, index) => {
          if (index < 4)
            return (
              <div className="footer-project" key={`div-${index}`}>
                <Image
                  src={project.thumbnail}
                  alt="Project Image"
                  style={{
                    cursor: "pointer",
                  }}
                />
              </div>
            );
        })}
      </div>
    </div>
  );
};
